import $ from "jquery";

/* ******************************************************************** */
/*                     Load Search Results Filters                      */
/* ******************************************************************** */
$(function () {
    if (!$('#core-search-aside-wrapper.core-search-results-sidebar').length) {
        return;
    }
    let searchParams = window.location.search.replace("?", "");
    $.ajax({
        type: 'get',
        dataType: 'html',
        beforeSend: function (xhr) {
            xhr.setRequestHeader('X-WP-Nonce', searchApi.nonce); // Set the nonce in the request header
        },
        url: searchApi.baseUrl + "/filters/",
        data: searchParams,
        success(response) {
            $('#core-search-aside-wrapper').replaceWith(response);
        },
    });
});

/* ******************************************************************** */
/*   Update search param in filters form when user edits the search     */
/* ******************************************************************** */
$(function () {
    $("#core-search-input").on("blur", function () {
        $("#core-search-mobile-filters-search-input").val($(this).val());
        $("#core-search-side-filters-search-input").val($(this).val());
        $('.core-search-filter-submit').prop('disabled', false);
    });
});

/* ******************************************************************** */
/*          Reload search results after display option changed          */
/* ******************************************************************** */
$(".core-search-display-option-form-select").on("change", function () {
    var url = $(this).val();
    window.location.href = url;
});

/* ******************************************************************** */
/*         Expand search result description (View/Hide Buttons)         */
/* ******************************************************************** */
$(function () {
    $(".core-search-results").on("click", ".core-search-result-more-details", function () {
        let $this = $(this);
        let shouldExpand = "false" === $(this).attr("aria-expanded");
        let abstract = $('#' + $(this).data('controls'));
        if (shouldExpand) {
            abstract.addClass('is-expanded');
            $this.attr("aria-expanded", "true");
            let expandButtonSpan = $($this.children('.core-search-result-expand-more-details')[0]);
            expandButtonSpan.text('Hide ' + expandButtonSpan.data('label'));
            $this.children('i').removeClass('fa-chevron-down').addClass('fa-chevron-up');
        } else {
            abstract.removeClass('is-expanded');
            $this.attr("aria-expanded", "false");
            let expandButtonSpan = $($this.children('.core-search-result-expand-more-details')[0]);
            expandButtonSpan.text('View ' + expandButtonSpan.data('label'));
            $this.children('i').addClass('fa-chevron-down').removeClass('fa-chevron-up');
        }
    });
});
